enum AppGroupType {
    Pressreader = 'pr',
    BrandedEditions = 'be',
}

const VALID_APP_GROUP_TYPES = [AppGroupType.Pressreader, AppGroupType.BrandedEditions] as const;

export { AppGroupType, VALID_APP_GROUP_TYPES };
